module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-06.5b149f9c.png";